<section>
    <form [formGroup]="newPasswordForm">
        <h1 *ngIf="showTitle">{{ title }}</h1>
        <p *ngIf="subTitle !== ''">{{ subTitle }}</p>
        <div *ngIf="requirementsAboveFields && showRequirements">
            <p>Password requires at least:</p>
            <div class="requirements">
                <div class="icons">
                    <mat-icon *ngIf="passwordRequirements?.hasMinLength; else noMin">check</mat-icon>
                    <ng-template #noMin>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.hasLower; else noLower">check</mat-icon>
                    <ng-template #noLower>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.hasUpper; else noUpper">check</mat-icon>
                    <ng-template #noUpper>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.hasNumber; else noNum">check</mat-icon>
                    <ng-template #noNum>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.hasSpecialChar; else noSpecialChar">check</mat-icon>
                    <ng-template #noSpecialChar>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.bothMatch; else noMatch">check</mat-icon>
                    <ng-template #noMatch>
                        <mat-icon></mat-icon>
                    </ng-template>
                </div>
                <ul>
                    <li [ngClass]="passwordRequirements?.hasMinLength ? 'requirement-met' : 'requirement-not-met'">A minimum of 8 characters</li>
                    <li [ngClass]="passwordRequirements?.hasLower ? 'requirement-met' : 'requirement-not-met'">A lowercase letter</li>
                    <li [ngClass]="passwordRequirements?.hasUpper ? 'requirement-met' : 'requirement-not-met'">An uppercase letter</li>
                    <li [ngClass]="passwordRequirements?.hasNumber ? 'requirement-met' : 'requirement-not-met'">A number</li>
                    <li [ngClass]="passwordRequirements?.hasSpecialChar ? 'requirement-met' : 'requirement-not-met'">
                        Any special character (the "_" character is not a special character)
                    </li>
                    <li [ngClass]="passwordRequirements?.bothMatch ? 'requirement-met' : 'requirement-not-met'">Both passwords must match</li>
                </ul>
            </div>
        </div>
        <mat-form-field appearance="fill">
            <mat-label>{{ hideConfirmPassword ? 'Password' : 'New Password' }}</mat-label>
            <input
                [type]="viewPassword[0] ? 'text' : 'password'"
                autocomplete="off"
                matInput
                formControlName="password"
                maxlength="30"
                [host]="this"
                appValidatePassword="password"
                (change)="validityCheck()"
                (keyup)="validityCheck()"
            />
            <mat-icon *ngIf="!viewPassword[0]" matSuffix (click)="togglePasswordVisible(1)" class="my-icon">visibility</mat-icon>
            <mat-icon *ngIf="viewPassword[0]" matSuffix (click)="togglePasswordVisible(1)" class="my-icon">visibility_off</mat-icon>
            <mat-error>Invalid password</mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" *ngIf="!hideConfirmPassword">
            <mat-label>Confirm New Password</mat-label>
            <input
                [type]="viewPassword[1] ? 'text' : 'password'"
                autocomplete="new-password"
                matInput
                formControlName="password2"
                [host]="this"
                appValidatePassword="password2"
                (change)="validityCheck()"
                (keyup)="validityCheck()"
            />
            <mat-icon *ngIf="!viewPassword[1]" matSuffix (click)="togglePasswordVisible(2)" class="my-icon">visibility</mat-icon>
            <mat-icon *ngIf="viewPassword[1]" matSuffix (click)="togglePasswordVisible(2)" class="my-icon">visibility_off</mat-icon>
            <mat-error *ngIf="newPasswordForm.get('password2')?.errors?.noMatch">Both passwords must match</mat-error>
            <mat-error *ngIf="newPasswordForm.get('password2')?.errors?.required">Invalid password</mat-error>
        </mat-form-field>
        <div *ngIf="!requirementsAboveFields && showRequirements">
            <p>Password requires at least:</p>
            <div class="requirements">
                <div class="icons">
                    <mat-icon *ngIf="passwordRequirements?.hasMinLength; else noMin">check</mat-icon>
                    <ng-template #noMin>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.hasLower; else noLower">check</mat-icon>
                    <ng-template #noLower>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.hasUpper; else noUpper">check</mat-icon>
                    <ng-template #noUpper>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.hasNumber; else noNum">check</mat-icon>
                    <ng-template #noNum>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.hasSpecialChar; else noSpecialChar">check</mat-icon>
                    <ng-template #noSpecialChar>
                        <mat-icon></mat-icon>
                    </ng-template>
                    <mat-icon *ngIf="passwordRequirements?.bothMatch; else noMatch">check</mat-icon>
                    <ng-template #noMatch>
                        <mat-icon></mat-icon>
                    </ng-template>
                </div>
                <ul>
                    <li [ngClass]="passwordRequirements?.hasMinLength ? 'requirement-met' : 'requirement-not-met'">A minimum of 8 characters</li>
                    <li [ngClass]="passwordRequirements?.hasLower ? 'requirement-met' : 'requirement-not-met'">A lowercase letter</li>
                    <li [ngClass]="passwordRequirements?.hasUpper ? 'requirement-met' : 'requirement-not-met'">An uppercase letter</li>
                    <li [ngClass]="passwordRequirements?.hasNumber ? 'requirement-met' : 'requirement-not-met'">A number</li>
                    <li [ngClass]="passwordRequirements?.hasSpecialChar ? 'requirement-met' : 'requirement-not-met'">
                        Any special character (the "_" character is not a special character)
                    </li>
                    <li [ngClass]="passwordRequirements?.bothMatch ? 'requirement-met' : 'requirement-not-met'">Both passwords must match</li>
                </ul>
            </div>
        </div>
    </form>
</section>
